module.exports = __webpack_public_path__ + "img/官网-V1_03.bdcf7f10.png";